// extracted by css-extract-rspack-plugin
export default {"wrapper":"_bad5550d"};